import apiServices from "../../ApiServices/request-handler";
import { requestHandler } from "../../utils/functions";
import {
  setAlertDropdowns,
  setAlertLoading,
  setAlerts,
  setIsAlertCall,
} from "../slices/alertSlice";

export const getAlertDropdown = () => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getAlertDropdown,
        setData: setAlertDropdowns,
      })
    );
  };
};

export const getAlerts = () => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getAlerts,
        onDone: (val) => {
          dispatch(setIsAlertCall(true))
          dispatch(setAlerts(val?.result?.alertSymbolList));
        },
        isErrorMessage: false,
      })
    );
  };
};

export const createAlert = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAlertLoading,
        apiService: apiServices.createAlert,
        param_data: data,
        isSuccessMessage: true,
        onDone: (val) => onDone(),
      })
    );
  };
};

export const editAlert = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAlertLoading,
        apiService: apiServices.editAlert,
        param_data: data,
        isSuccessMessage: true,
        onDone: (val) => {
          dispatch(getAlerts());
          onDone();
        },
      })
    );
  };
};

export const deleteAlert = (data) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAlertLoading,
        apiService: apiServices.deleteAlert,
        param_data: data,
        isSuccessMessage: true,
        onDone: (val) => {
          dispatch(getAlerts());
        },
      })
    );
  };
};
